import { createReducer } from '@reduxjs/toolkit'

import type { StorageState } from '@/types'
import { removeAttachmentItems } from '@/utils/attachments'
import { decreaseStorageLimits, increaseStorageLimits } from '@/utils/storage'
import { InternalStorageActions } from './actions'
import { storageState } from './initialState'

export const storage = createReducer<StorageState>(storageState, (builder) => {
  builder
    .addCase(InternalStorageActions.setQuota, (state, { payload }) => {
      state.quota = payload
    })
    .addCase(InternalStorageActions.setStorage, (state, { payload }) => {
      state.limits = payload
    })
    .addCase(InternalStorageActions.setAttachments, (state, { payload }) => {
      state.items = payload
    })
    .addCase(InternalStorageActions.removeAttachments, (state, { payload }) => {
      state.items = removeAttachmentItems(state.items, payload)
      state.limits = decreaseStorageLimits(state.limits, payload)
      if (state.quota) {
        state.quota.limits = decreaseStorageLimits(state.quota.limits, payload)
      }
    })
    .addCase(InternalStorageActions.appendAttachments, (state, { payload }) => {
      state.items = [...state.items, ...payload]
      state.limits = increaseStorageLimits(state.limits, payload)
      if (state.quota) {
        state.quota.limits = increaseStorageLimits(state.quota.limits, payload)
      }
    })
})
